"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var batchEventBus_1 = __importDefault(require("./batchEventBus"));
var BatchApi = /** @class */ (function () {
    function BatchApi() {
    }
    Object.defineProperty(BatchApi.prototype, "isBatchOpen", {
        get: function () {
            return batchEventBus_1.default.isBatchOpen;
        },
        enumerable: true,
        configurable: true
    });
    BatchApi.prototype.startBatch = function () {
        batchEventBus_1.default.startBatch();
    };
    BatchApi.prototype.closeBatch = function () {
        return batchEventBus_1.default.completeBatch();
    };
    BatchApi.prototype.runBatched = function (runnerMethod) {
        if (!batchEventBus_1.default.isBatchOpen) {
            batchEventBus_1.default.startBatch();
            runnerMethod();
            return batchEventBus_1.default.completeBatch();
        }
        return Promise.resolve();
    };
    return BatchApi;
}());
exports.BatchApi = BatchApi;
